import type { InfoPopupState } from '../shared/infoPopup/infoPopupState';

export type RatingScreenProps = {
  averageRating?: number;
  onInfoClick?: () => void;
  onGoBack?: () => void;
};

export type RatingScreenState = InfoPopupState;

export type RatingScreenModel = InfoPopupState & {
  averageRating?: number;
  onInfoClick?: () => void;
  onGoBack?: () => void;
};

export function createRatingScreenModel(
  props: RatingScreenProps,
  state: RatingScreenState,
): RatingScreenModel {
  return {
    infoOpen: state.infoOpen,
    setInfoOpen: state.setInfoOpen,
    averageRating: props.averageRating,
    onInfoClick: props.onInfoClick,
    onGoBack: props.onGoBack,
  };
}
